import React, { useEffect, useState } from 'react';
import PageArticle from '../../components/_template/page/PageArticle';
import KitTab from '../../components/_atom/tab/KitTab';
import '../../styles/ManageKit.scss';
import { TokenKit } from '../../assets/constant/tokenKit.type';
import { logic } from '../../../logic';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { networkParserNew } from '../../../utils/Utils';
import DivideLine from '../../components/_atom/line/DivideLine';
import useLoading from '../../../hooks/useLoading';
import PageLoading from '../../components/_atom/loading/PageLoading';
import TableStatus, { TABLE_STATUS } from './components/TableStatus';
import KitContainer from './components/KitContainer';
import iconToggle from '../../assets/images/icon_upper_arrow_circle.png';
import { statusType } from '../../../utils/status.utils';
import TransactionStatus from '../../components/_atom/transactionStatus/TransactionStatus';
import LabelValue from './components/LabelValue';
import Setting from './components/Setting';
import { ConnectedWallet, KindOfKit, KitFunction, KitFunctionMethod, KitType } from '../../assets/constant/kit.type';
import { KIT_TABS } from '../../assets/constant/kit.constant';
import MethodContainer from './components/function/MethodContainer';
import AccountManager from './components/manager/account/AccountManager';
import ContractManager from './components/manager/contract/ContractManager';
import WebhookManager from './components/manager/webhook/WebhookManager';
import EQConnectWalletButtonWithMetamask from '../../../modules/EQConnect/EQConnectWalletButtonWithMetamask';
import iconRefresh from '../../assets/images/icon_refresh_blue.png';
import toast from 'react-hot-toast';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ReactComponent as IconCopy } from '../../assets/images/icon_copy.svg';
import Skeleton from '../../components/_atom/skeleton/Skeleton';
import OwnerBadge from './components/OwnerBadge';
import Select from '../../components/_atom/select/Select';
import iconFailTransaction from '../../assets/images/Icon_fail_transaction.png';

const ManageTokenKit = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (Array.from(searchParams.keys()).length > 0) {
      setSearchParams({}, { replace: true });
    }
  }, [tabIndex]);
  const [isOpenDescription, setIsOpenDescription] = useState(false);
  const params = useParams();
  const { id: kit_id } = params;
  const [kitDetail, setKitDetail] = useState<TokenKit>();
  const [kitType, setKitType] = useState<KitType>();
  const status =
    kitDetail?.status === 4
      ? TABLE_STATUS.DEPLOYED
      : kitDetail?.status === 3
        ? TABLE_STATUS.PROCESSING
        : kitDetail?.status === 2
          ? TABLE_STATUS.PREPARED
          : TABLE_STATUS.CREATED;
  const navigate = useNavigate();
  const getTokenKitDetail = async (kit_id: number) => {
    const { result, error } = await logic.tokenKit.getTokenKitDetail(kit_id);
    if (error) {
      if (error.data === 'not_access') {
        navigate('/');
      }
      return;
    }
    const { result: kitType, error: kitTypeError } = await logic.tokenKit.getTokenKitTypeDetail(result?.version?.kit_type_id);
    if (kitTypeError) {
      return;
    }
    const { result: microChains, error: microChainsError } = await logic.microChain.getMicroChainList({});
    if (microChainsError) {
      return;
    }
    const networks = networkParserNew(microChains);
    const network = networks.find((network) => network.id === result.chain_id);
    const tokenKit: TokenKit = {
      ...result,
      network: network?.label,
    };
    setKitDetail(tokenKit);
    setKitType(kitType);
  };
  const [connectedWallet, setConnectedWallet] = useState<ConnectedWallet>({
    connectWalletType: '',
    connectAddress: '',
  });
  const [coinBalance, setCoinBalance] = useState<{ amount: number; unit: string; image: string }>();
  const getCoinBalance = async (address: string) => {
    if (!kitDetail?.chain_id) {
      return;
    }
    const { result, error } = await logic.tokenKit.getCoinBalance(kitDetail?.chain_id, [address]);
    const { result: currencyInfos, error: coinInfosError } = await logic.currency.getCoinInfos({ originMicroChainIds: [kitDetail?.chain_id] });
    if (coinInfosError) {
      return;
    }
    const coinInfo = currencyInfos ? currencyInfos[0] : null;
    const currentBalance = result?.find((balance) => balance.address === address);
    setCoinBalance({
      amount: currentBalance?.balance,
      unit: coinInfo ? coinInfo?.symbol : '',
      image: coinInfo ? coinInfo.image : '',
    });
  };
  const { loading: loadingCoinBalance } = useLoading({
    dependency: [connectedWallet.connectAddress, kitDetail],
    synchronousFunction: async () => {
      const connectedAddress = connectedWallet.connectAddress;
      if (connectedAddress) {
        await getCoinBalance(connectedAddress);
      }
    },
  });
  const [tokenBalance, setTokenBalance] = useState<{ amount: number; unit: string; image: string }>();
  const getTokenBalance = async (address: string) => {
    if (!kitDetail?.chain_id) {
      return;
    }
    const { result, error } = await logic.tokenKit.getTokenBalance(kitDetail?.kit_id, [address]);
    const currentBalance = result?.find((balance) => balance.address === address);
    setTokenBalance({ amount: currentBalance?.balance, unit: kitDetail?.symbol, image: kitDetail?.image });
  };
  const { loading: loadingTokenBalance } = useLoading({
    dependency: [connectedWallet.connectAddress, kitDetail],
    synchronousFunction: async () => {
      const connectedAddress = connectedWallet.connectAddress;
      if (connectedAddress) {
        await getTokenBalance(connectedAddress);
      }
    },
  });
  const refreshBalance = async () => {
    setCoinBalance(undefined);
    setTokenBalance(undefined);
    toast.loading('Refreshing balance...');
    if (connectedWallet.connectAddress) {
      await getCoinBalance(connectedWallet.connectAddress);
      await getTokenBalance(connectedWallet.connectAddress);
    }
    toast.success('Refreshed balance!');
  };

  const [transactionHash, setTransactionHash] = useState('');

  const { loading } = useLoading({
    dependency: [kit_id],
    synchronousFunction: async () => {
      await getTokenKitDetail(Number(kit_id));
    },
  });
  const { version } = kitDetail || {};
  if (loading) {
    return <PageLoading />;
  }
  return (
    <PageArticle id="ManageKit">
      <div
        style={
          {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            position: 'relative',
            '--kit-title-wrapper-height':
              kitDetail?.status === 3 && transactionHash ? (isOpenDescription ? '506px' : '368px') : isOpenDescription ? '340px' : '200px',
          } as React.CSSProperties
        }
      >
        <div style={{ position: 'sticky', width: '100%', zIndex: 100, top: 0 }}>
          <div className="kit-title-wrapper">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="kit-info-wrapper" onClick={() => setIsOpenDescription(!isOpenDescription)}>
                <img src={kitDetail?.image} alt="token image" className={`kit-info-image${isOpenDescription ? ' open' : ''}`} />
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 20,
                    }}
                  >
                    <div className="kit-info-name">{kitDetail?.name}</div>
                    <img src={iconToggle} alt="toggle" className={`kit-info-toggle${isOpenDescription ? ' open' : ''}`} />
                  </div>
                  {isOpenDescription && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 20,
                        marginTop: 10,
                      }}
                    >
                      <div className="kit-info-text">Type : {kitType?.name}</div>
                      <div className="kit-info-text">Version : {version?.version}</div>
                      <TableStatus status={status} />
                    </div>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, alignSelf: 'flex-start' }}>
                {connectedWallet.connectAddress && kitDetail?.status !== 1 && (
                  <div className="balance-container">
                    {loadingCoinBalance && loadingTokenBalance ? (
                      <Skeleton type={'default'} style={{ width: 150, height: 20 }} />
                    ) : (
                      <>
                        {[coinBalance, tokenBalance].map((balance, index) => {
                          const loading = index === 0 ? loadingCoinBalance : loadingTokenBalance;
                          return (
                            <div className="balance-info-wrapper" key={index}>
                              {loading || !balance ? (
                                <Skeleton type={'default'} style={{ width: 75, height: 20 }} />
                              ) : (
                                <>
                                  <img src={balance?.image} alt="token image" className="balance-info-image" />
                                  <div className="balance-info-value">{balance?.amount !== undefined || loading ? balance?.amount : '-'}</div>
                                  <div className="balance-info-unit">{balance?.unit}</div>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </>
                    )}
                    <img src={iconRefresh} alt="refresh" className="balance-refresh-icon" onClick={refreshBalance} />
                  </div>
                )}
                <EQConnectWalletButtonWithMetamask connectedWallet={connectedWallet} setConnectedWallet={setConnectedWallet} kitDetail={kitDetail} />
              </div>
            </div>
            {isOpenDescription && version?.description && version.description.length > 0 && (
              <>
                <DivideLine style={{ margin: '20px 0' }} />
                <div className="kit-description">{version.description}</div>
              </>
            )}
          </div>
          {kitDetail?.status === 3 && transactionHash && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '10px 50px 20px',
                backgroundColor: '#F9F9F9',
              }}
            >
              <div style={{ width: '768px', marginBottom: -20 }}>
                <TransactionStatus
                  transactionHash={transactionHash}
                  statusDetail={{
                    type: statusType.WAIT,
                    title: 'Smart contract is being deployed.',
                    showTransactionHash: true,
                  }}
                  microChainId={kitDetail?.chain_id as number}
                  type={'small'}
                />
              </div>
            </div>
          )}
          <div className="kit-tab-wrapper">
            <KitTab tabs={KIT_TABS} tabIndex={tabIndex} setTabIndex={setTabIndex} />
          </div>
        </div>
        {tabIndex === 0 && <Dashboard kitDetail={kitDetail!} setTabIndex={setTabIndex} />}
        {tabIndex === 1 && <Function kitDetail={kitDetail!} connectedWallet={connectedWallet} setTabIndex={setTabIndex} />}
        {tabIndex === 2 && (
          <Dev
            kitDetail={kitDetail!}
            setKitDetail={setKitDetail}
            setTransactionHash={setTransactionHash}
            connectedWallet={connectedWallet}
            setConnectedWallet={setConnectedWallet}
          />
        )}
        {tabIndex === 3 && <Setting kitDetail={kitDetail!} kindOfKit={KindOfKit.TokenKit} setTabIndex={setTabIndex} />}
      </div>
    </PageArticle>
  );
};

export default ManageTokenKit;

const Dashboard = ({ kitDetail, setTabIndex }: { kitDetail: TokenKit; setTabIndex: (tabIndex: number) => void }) => {
  const status =
    kitDetail?.status === 4
      ? TABLE_STATUS.DEPLOYED
      : kitDetail?.status === 3
        ? TABLE_STATUS.PROCESSING
        : kitDetail?.status === 2
          ? TABLE_STATUS.PREPARED
          : TABLE_STATUS.CREATED;
  const datas = [
    { label: 'Kit ID', value: kitDetail?.kit_id },
    { label: 'Kit Name', value: kitDetail?.name },
    {
      label: 'Kit Image',
      value: <img src={kitDetail?.image} alt={''} className={'kit-info-image'} />,
    },
    { label: 'Token Symbol', value: kitDetail?.symbol },
    { label: 'Status', value: <TableStatus status={status} /> },
    { label: 'Kit Version', value: kitDetail?.version?.version },
    {
      label: 'Kit Owner Account',
      value: (
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {kitDetail?.admin_address}
          <CopyToClipboard text={kitDetail?.admin_address} onCopy={() => toast('Owner Account Copied', { icon: '👏' })}>
            <IconCopy style={{ minWidth: 20, minHeight: 20, objectFit: 'contain', cursor: 'pointer' }} className="icon-copy" />
          </CopyToClipboard>
        </div>
      ),
    },
  ];
  return (
    <div className="tab-content-wrapper">
      {kitDetail?.status !== 4 && (
        <div style={{ padding: 20, borderRadius: 8, background: '#E4E6EB', width: '100%' }}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, alignItems: 'center' }}>
            <img src={iconFailTransaction} alt="icon_fail_transaction" style={{ width: 24, height: 24, objectFit: 'contain' }} />
            <div style={{ fontWeight: 700, fontSize: 16, lineHeight: '21px' }}>Note : Pre-requisite for using functions</div>
          </div>
          <div
            onClick={() => setTabIndex(2)}
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '20px',
              whiteSpace: 'pre-line',
              color: '#5888ff',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Deploy contract to use this kit.
          </div>
        </div>
      )}
      <KitContainer
        title={'Kit Basic Info'}
        // description="The Setting tab allows users to configure token details, manage access permissions, customize appearance, and optimize operational settings for seamless management."
      >
        {datas.map((data, index) => {
          return <LabelValue key={index} label={data.label} value={data.value} />;
        })}
      </KitContainer>
    </div>
  );
};

const Function = ({
  kitDetail,
  connectedWallet,
  setTabIndex,
}: {
  kitDetail: TokenKit;
  connectedWallet: ConnectedWallet;
  setTabIndex: (tabIndex: number) => void;
}) => {
  const [functions, setFunctions] = useState<KitFunction[]>([]);
  const [selectedFunction, setSelectedFunction] = useState<KitFunction>();
  const getFunctions = async (kitId: number) => {
    const { result, error } = await logic.tokenKit.getTokenFunctionList(kitId);
    if (error) {
      return;
    }
    setFunctions(result);
    setSelectedFunction(result[0]);
  };
  const { loading } = useLoading({
    dependency: [kitDetail?.kit_id],
    synchronousFunction: async () => {
      await getFunctions(kitDetail?.kit_id);
    },
  });
  const [selectedFunctionMethods, setSelectedFunctionMethods] = useState<KitFunctionMethod[]>([]);
  const getFunctionMethods = async (selectedFunction: KitFunction) => {
    const { result, error } = await logic.metadataManager.getMetadataTemplate({
      categoryIdentifiers: [kitDetail.category_identifier],
      types: [selectedFunction?.name],
    });
    if (error) {
      return;
    }
    const functionMethods = result?.rows[0]?.template_data;
    setSelectedFunctionMethods(functionMethods);
  };
  useEffect(() => {
    if (selectedFunction) {
      getFunctionMethods(selectedFunction);
    }
  }, [selectedFunction]);
  const functionMethodsForSelect = selectedFunctionMethods?.map((method) => {
    const { method_name, owner_only } = method;
    return {
      label: (
        <div style={{ display: 'flex', gap: 4, alignItems: 'center', height: 24 }}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 400,
              lineHeight: '100%',
              letterSpacing: 0,
            }}
          >
            {method_name}
          </div>
          {owner_only && <OwnerBadge useText={false} />}
        </div>
      ),
      value: method,
    };
  });
  const [selectedMethod, setSelectedMethod] = useState<any>();

  const [hasTXWebhook, setHasTXWebhook] = useState<boolean>(false);
  const checkTXWebhook = async () => {
    const { result, error } = await logic.webhook.getWebhookList({
      limit: 1,
      eventName: 'TRANSACTION',
    });
    if (error) {
      return;
    }
    const { data: webhooks } = result;
    setHasTXWebhook(webhooks.length > 0);
  };
  useEffect(() => {
    checkTXWebhook();
  }, []);

  if (loading) {
    return <PageLoading />;
  }
  return (
    <div style={{ display: 'flex', height: '100%' }}>
      <div className="sub-menu-container">
        <div className="sub-menu-wrapper">
          {functions.map((func, index) => (
            <div
              key={index}
              className={`sub-menu-name${selectedFunction?.feature_id === func?.feature_id ? ' selected' : ''}`}
              onClick={() => {
                setSelectedMethod(undefined);
                setSelectedFunction(func);
              }}
            >
              {func.name}
            </div>
          ))}
        </div>
      </div>
      <div className="tab-content-wrapper">
        <div style={{ display: 'flex', width: '100%', gap: 20 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 20,
            }}
          >
            {kitDetail?.status !== 4 && (
              <div style={{ padding: 20, borderRadius: 8, background: '#E4E6EB' }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12, alignItems: 'center' }}>
                  <img src={iconFailTransaction} alt="icon_fail_transaction" style={{ width: 24, height: 24, objectFit: 'contain' }} />
                  <div style={{ fontWeight: 700, fontSize: 16, lineHeight: '21px' }}>Note : Pre-requisite for using functions</div>
                </div>
                <div
                  onClick={() => setTabIndex(2)}
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: '20px',
                    whiteSpace: 'pre-line',
                    color: '#5888ff',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                  Deploy contract to access 'Function'
                </div>
              </div>
            )}
            <div className="kit-container" style={{ gap: 10 }}>
              <div
                className="kit-container-title"
                style={{
                  fontSize: 28,
                  fontWeight: 700,
                  lineHeight: '36px',
                  letterSpacing: -0.03,
                }}
              >
                {selectedFunction?.name ?? ''}
              </div>
              <div
                className="kit-container-description"
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  lineHeight: '24px',
                  letterSpacing: -0.01,
                }}
              >
                {selectedFunction?.description}
              </div>
            </div>
            <KitContainer title={'Select Request'}>
              <Select
                options={functionMethodsForSelect}
                placeholder={'Select the request you want to send'}
                selectedValue={selectedMethod}
                setSelectedValue={setSelectedMethod}
              />
            </KitContainer>
            {selectedMethod && (
              <MethodContainer
                method={selectedMethod}
                selectedFunction={selectedFunction}
                kitDetail={kitDetail}
                connectedWallet={connectedWallet}
                hasTXWebhook={hasTXWebhook}
                kitType={KindOfKit.TokenKit}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const DEV_SUBMENU = [
  { name: 'Contract Manager', id: 0 },
  { name: 'Account Manager', id: 1 },
  { name: 'Webhook Manager', id: 2 },
];
const Dev = ({
  kitDetail,
  setKitDetail,
  setTransactionHash,
  connectedWallet,
  setConnectedWallet,
}: {
  kitDetail: TokenKit;
  setKitDetail: Function;
  setTransactionHash: Function;
  connectedWallet: ConnectedWallet;
  setConnectedWallet: Function;
}) => {
  const [selectedSubmenu, setSelectedSubmenu] = useState<{
    name: string;
    id: number;
  }>(DEV_SUBMENU[0]);
  return (
    <div style={{ display: 'flex', flex: 1 }}>
      <div className="sub-menu-container">
        <div className="sub-menu-wrapper">
          {DEV_SUBMENU.map((subMenu, index) => (
            <div key={index} className={`sub-menu-name${selectedSubmenu?.id === subMenu?.id ? ' selected' : ''}`} onClick={() => setSelectedSubmenu(subMenu)}>
              {subMenu.name}
            </div>
          ))}
        </div>
      </div>
      {selectedSubmenu.id === 0 && (
        <ContractManager
          kitDetail={kitDetail}
          kindOfKit={KindOfKit.TokenKit}
          setKitDetail={setKitDetail}
          setTransactionHash={setTransactionHash}
          connectedWallet={connectedWallet}
          setConnectedWallet={setConnectedWallet}
        />
      )}
      {selectedSubmenu.id === 1 && <AccountManager kitDetail={kitDetail} kindOfKit={KindOfKit.TokenKit} />}
      {selectedSubmenu.id === 2 && <WebhookManager kitDetail={kitDetail} kindOfKit={KindOfKit.TokenKit} />}
    </div>
  );
};
